import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';

const DefaultNotification = ({ notification }) => {
  const meta = getMeta(notification);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={meta.subIcon} />
      <div className="min-w-0 my-auto">
        <p className="font-normal text-sm break-words">{meta.description}</p>
      </div>
    </div>
  );
};

export default DefaultNotification;
